exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".capacity-setting[data-v-a50014a0]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.capacity-setting .el-input-number[data-v-a50014a0]{width:160px}.capacity-tip[data-v-a50014a0]{margin-left:8px;color:#909399}.vip-title[data-v-a50014a0]{margin-left:28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a50014a0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/roles/index.vue
// module id = 2522
// module chunks = 0